module.exports = __webpack_public_path__ + "img/playDetails.33502b62.jpg";